function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { MdaInit } from 'modules/Meter';
var _React_PureComponent;
class Initializing extends (_React_PureComponent = React.PureComponent) {
    render() {
        return /*#__PURE__*/ _jsx(MdaInit, {
            initComponent: this.props.subComponent,
            onInitialized: ()=>this.props.onSetComponent('ChooseDatabase')
        });
    }
}
_define_property(Initializing, "propTypes", {
    // Explicit props
    subComponent: PropTypes.string,
    // Explicit actions
    onSetComponent: PropTypes.func
});
export default Initializing;
